import { showFailToast } from 'vant';
// 获取account_id
export async function getAccountId() {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.getAccountId({
            completed: (data) => {
                console.log(data);
                resolve(data.account_id);
            },
            cpIncompatible: () => {
                showFailToast('请先登录世界青田APP');
                reject('此环境不支持此方法');
            }
        });
    });
}

// 获取session_id
export async function getSessionId() {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.getUniqueId({
            completed: (data) => {
                console.log(data);
                resolve(data.unique_id);
            },
            cpIncompatible: () => {
                showFailToast('请先登录世界青田APP');
                reject('此环境不支持此方法');
            }
        });
    });
}

export async function getClientInfo() {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.getClientInfo({
            completed: function (data) {
                console.log(data);
                resolve(data);
            },
            cpIncompatible: function () {
                reject('此环境不支持此方法');
            }
        });
    });
}

export async function getDeviceInfo() {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.getDeviceInfo({
            completed: function (data) {
                console.log(data);
                resolve(data);
            },
            cpIncompatible: function () {
                reject('此环境不支持此方法');
            }
        });
    });
}

export async function getCustomerInfo() {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.getCustomerInfo({
            completed: function (data) {
                console.log(data);
                resolve(data);
            },
            cpIncompatible: function () {
                reject('此环境不支持此方法');
            }
        });
    });
}

export async function isLogin() {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.isLogin({
            completed: function (data) {
                console.log(data);
                resolve(data);
            },
            cpIncompatible: function () {
                reject('此环境不支持此方法');
            }
        });
    });
}

export async function showLogin() {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.showLogin({
            completed: function (data) {
                console.log(data);
                resolve(data);
            },
            cpIncompatible: function () {
                reject('此环境不支持此方法');
            }
        });
    });
}

export async function showShare() {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.showShare({
            completed: function (data) {
                console.log(data);
                resolve(data);
            },
            cpIncompatible: function () {
                reject('此环境不支持此方法');
            },
            title: '请查收！世界青田App2023年度热词来啦',
            shareTo: '',
            link: 'https://app.tmuyun.com/webDetails/news?id=7083450&tenantId=48&uid=62a97c0ab77d2e52063a996f',
            imgUrl: 'http://nzhd.raqq.cn/profile/nzhd/share.jpg',
            shareSummary: '来自 世界青田',
            id: '',
            type: '',
            datatype: '',
            dataUrl: '',
        });
    });
}

export async function setShare() {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.setShare({
            completed: function (data) {
                console.log(data);
                resolve(data);
            },
            cpIncompatible: function () {
                reject('此环境不支持此方法');
            },
            'title': '请查收！世界青田App2023年度热词来啦',
            'shareTo': '',
            'link': 'https://app.tmuyun.com/webDetails/news?id=7083450&tenantId=48&uid=62a97c0ab77d2e52063a996f',
            'imgUrl': 'http://nzhd.raqq.cn/profile/nzhd/share.jpg',
            'shareSummary': '来自 世界青田',
            'id': '',
            'type': '',
            'datatype': '',
            'dataUrl': '',
            'shareUrlScheme': '',
            'success': function () { console && console.log('用户已分享') }
        });
    });
}

export async function openInApp() {
    return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        CP.openInApp({
            completed: function (data) {
                console.log(data);
                resolve(data);
            },
            cpIncompatible: function () {
                console.log('此环境不支持此方法')
                reject('此环境不支持此方法');

            },
            timeout: 1000,
            defaultClient: { 'client_code': 'xsb_ruian' },
            directJump: 1,
            link_url: "https://app.tmuyun.com/webDetails/news?id=7083450&tenantId=48&uid=6217771ffe3fc178d1aa288a",
            id: '',
            tenantId: ''
        });
    });
}